import src from "IMAGE";
export default { src, width: 2000, height: 200, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAIQHyoGEh8rAg4aIwEMFx4ADBYeAAsVHQALFBwACxQbJzACP1qZBTEAAAAASUVORK5CYII="};
